// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"ada6158a6761581dfad1","691":"02ae37df8e5d9bcd06c6"}[chunkId] + ".js";
};